export function FormulaNumber({ formulaNumber }: { formulaNumber: string | null }) {
  return formulaNumber === null ? <>(No formula number)</> : <>#{formulaNumber}</>;
}
